
import MapCommandClearAllMeasure from './MapCommandClearAllMeasure';
import MapCommandExecCode from './MapCommandExecCode';
import MapCommandHighlightFeature from './MapCommandHighlightFeature';
import MapCommandZoomFeature from './MapCommandZoomFeature';
import MapCommandRedraw from './MapCommandRedraw';
import MapCommandSetCenter from './MapCommandSetCenter';
import MapCommandSetMapTool from './MapCommandSetMapTool';
import MapCommandSetTempFeature from './MapCommandSetTempFeature';
import MapCommandZoomIn from './MapCommandZoomIn';
import MapCommandZoomOut from './MapCommandZoomOut';

export default class MapCommander {

    constructor(options) {
        this._options = options || {};
        this._list = [
            new MapCommandClearAllMeasure(),
            new MapCommandExecCode(),
            new MapCommandHighlightFeature(),
            new MapCommandZoomFeature(),
            new MapCommandRedraw(),
            new MapCommandSetCenter(),
            new MapCommandSetMapTool(),
            new MapCommandSetTempFeature(),
            new MapCommandZoomIn(),
            new MapCommandZoomOut(),
        ];
    }

    addCommand(command) {
        this._list.push(command);
    }

    execute(commandDef) {
        let command = this.getCommandByName(commandDef.name);
        if (command) {
            command.execute(this._options.olMap, commandDef.params);
            if (this._options.onCommandExecuted) {
                this._options.onCommandExecuted(commandDef.id);
            }
        }
    }

    getCommandByName(name) {
        return this._list.reduce((previous, current) => {
            return (current.getName() === name)
                ? current
                : previous;
        }, null);
    }
}
